import { Col, Row } from "antd";

export default function Header() {
  return (
    <Row align={"middle"} gutter={40}>
      <Col>
        <img height={48} src="/image/home/logo-horizontal.svg" alt="logo" />
      </Col>
      <Col>
        <p className="w-font-md fw-600" style={{ color: "#23262F" }}>
          Embedded Widget
          <span
            style={{
              color: "#FF774A",
              backgroundColor: "#FFE4DB",
              borderRadius: 16,
              padding: "2px 10px",
              marginLeft: 8,
              fontSize: 12,
            }}
          >
            BETA
          </span>
        </p>
      </Col>
    </Row>
  );
}
